import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from '@shared/components/ui/avatar';
import { BadgeComponent } from '@shared/components/ui/badge';
import { ErrorStateComponent } from '@shared/components/ui/error-state';
import { SkeletonLoaderComponent } from '@shared/components/ui/skeleton-loader';
import { IntlDateTimePipe } from '@shared/pipes';
import { PersonNounLabelPipe } from '@shared/person-noun/pipe';
import type { CompletedStudent } from '@live-pickup/data-access';
@Component({
  selector: 'lib-completed-list',
  standalone: true,
  imports: [AvatarComponent, BadgeComponent, ErrorStateComponent, SkeletonLoaderComponent, TranslateModule, IntlDateTimePipe, PersonNounLabelPipe],
  templateUrl: './completed-list.component.html',
})
export class CompletedListComponent {
  readonly students = input.required<CompletedStudent[]>();
  readonly hasError = input(false);
  readonly isLoading = input(false);
  readonly retry = output<void>();

  readonly skeletonRows = [0, 1, 2, 3, 4, 5];
}
